module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("注册协议")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('scroller', {
    ref: "scroller"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "30"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "left": "0",
      "top": "0",
      "height": "100%",
      "z-index": "20"
    }
  }), _vm._v(" "), _c('iframe', {
    ref: "iframe",
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "100%",
      "z-index": "10"
    },
    attrs: {
      "src": "/xieyi/yh.jsp",
      "frameborder": "0",
      "scrolling": "no"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fcd0222!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/protocol.vue
// module id = 336
// module chunks = 1